<div class="white-wrapper-container">
  <div class="layout-fluid-constrained layout-align-center white-wrapper">
    <h1 class="page-name">Новини</h1>

    <div class="news-list-wrapper">
      @if (newsListWrapper) {
        @if (newsListWrapper.newsList.length == 0) {
          <div class="formatted-text layout-align-content-center">
            <p>Няма намерени новини.</p>
          </div>
        } @else {
          @for (news of newsListWrapper.newsList; track $index) {
            <div class="news-list-item" [class.has-image]="news.image">
              <a routerLink="/news/{{getTranslation(news)?.slug}}" class="image-wrapper">
                @if (news.image) {
                  <img [src]="news.image.file | imageBase64Content: news.image.mimeType" alt="{{getTranslation(news)?.name}}">
                }
              </a>
              <div class="info-wrapper">
                <div class="date-wrapper">{{ news?.date | date: 'dd.MM.yyyy' }}</div>
                <a routerLink="/news/{{getTranslation(news)?.slug}}" class="name">{{ getTranslation(news)?.name }}</a>
                <div class="text" [innerHTML]="getTranslation(news)?.text.slice(0,400) "></div>
                <a routerLink="/news/{{getTranslation(news)?.slug}}" class="more-btn">Виж повече</a>
              </div>
            </div>
          }
        }
      }
    </div>
    <mat-paginator #paginator
                   class="paginator"
                   (page)="handlePaginatorChangeEvent($event)"
                   [length]="paginatorTotalItemsCount"
                   [pageSize]="2"
                   [showFirstLastButtons]="true"
                   [hidePageSize]="true"
                   [pageIndex]="page-1"
                   aria-label="Select page">
    </mat-paginator>
  </div>
</div>
